import React from "react";
import UserReferralPageSection from "../sections/UserReferralPageSection/Content";
const UserReferralPage = () => {
  return <UserReferralPageSection />;
};

export default UserReferralPage;
